import makeArray from '@glass/common/modules/utils/makeArray';

const areObjsEqualByKey = (keys, obj1, obj2) =>
  makeArray(keys).every((key) => obj1?.[key] === obj2?.[key]);

export default areObjsEqualByKey;
